import { makeStyles, PaperProps } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import React from 'react';

export type TableWrapperProps = PaperProps & {
    defaultMarginTop?: boolean
};

export function TableWrapper ({ children, className, defaultMarginTop, ...props }: TableWrapperProps) {
    const cls = useStyles();

    return (
        <Paper elevation={5} {...props} className={`${className} ${defaultMarginTop === true ? cls.defaultMarginTop : ""}`}>
            <TableContainer>
                { children }
            </TableContainer>
        </Paper>
    )
}

const useStyles = makeStyles(theme => ({
    defaultMarginTop: {
        marginTop: theme.spacing(2)
    }
}));